import React, { useState, useEffect, useMemo } from "react";
import OptionsContainer from "./OptionsSide/OptionsContainer.js";
import DetailsContainer from "./DetailsSide/DetailsContainer.js";
import Image from "components/Elements/Image/Image.tsx";
import config from "config";
import EmbedFormLogoUploader from "components/Reusable/EmbedFormLogoUploader/EmbedFormLogoUploader.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import CreateFormHeader from "./CreateFormHeader.js";
import FormBuilderContainer from "./NewFormBuilder/FormBuilderContainer/FormBuilderContainer.js";
import LoadingContainerElement from "components/Elements/LoadingContainerElement/LoadingContainerElement.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";
import {
  defaultFieldsFormBuilder,
  fieldStructure,
} from "./NewFormBuilder/Helper.js";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { embedColorCode } from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import { languageListObjects } from "utils/jumbomailSettings.js";
import { getSpecificReactConst } from "components/Reusable/EmbedFormTemplate/Helpers/EmbedApiCalls.js";
import {
  calculateBodyJumboForm,
  createEmbedDynamicFormReact,
} from "../Helpers/externalFunctions.js";
import { useBeforeunload } from "react-beforeunload";
import generateCopiedFieldLabel from "../Helpers/generateCopiedFieldLabel.ts";
import { cloneDeep } from "lodash";
import { EMAIL_VALIDATOR } from "helpers/validators.js";
import validateRecipient from "../Helpers/validateRecipient.js";

const CreateFormContainer = ({
  userData,
  formButtonsColor,
  setFormButtonsColor,
  formButtonTextColor,
  setFormButtonTextColor,
  formBackgroundColor,
  setFormBackgroundColor,
  editOrCreate,
  setFormLanguage,
  formId,
  setFormId,
  setFormWidth,
  formWidth,
  setFormHeight,
  formHeight,
  formLanguage,
  formJson,
  setFormJson,
  setFormDisplayTitle,
  formDisplayTitle,
  formDescription,
  setFormDescription,
  previewFormById,
  formImage,
  setFormImage,
  displayFooterLinks, //Footer links
  setDisplayFooterLinks,
  editCustomFooterLinks,
  setEditCustomFooterLinks,
  linkFooters,
  setLinkFooters,
  emailToReceiveFiles, //Settings
  setEmailToReceiveFiles,
  uploadFilesLimit,
  setUploadFilesLimit,
  fileSizeLimit,
  setFileSizeLimit,
  manuallyDeleteCheckbox,
  setManuallyDeleteCheckbox,
  automaticallyDeleteCheckbox,
  setAutomaticallyDeleteCheckbox,
  daysToDelete,
  setDaysToDelete,
  uploadAnyFormatsCheckbox,
  setUploadAnyFormatsCheckbox,
  allowFolowingFormatsCheckbox,
  setAllowFolowingFormatsCheckbox,
  denyForamtsCheckbox,
  setDenyForamtsCheckbox,
  fileFormats,
  setFileFormats,
  potentialCustomers,
  setPotentialCustomers,
  customersFilesDownloaded,
  setCustomersFilesDownloaded,
  orderConfirmation,
  setOrderConfirmation,
  sendEmailToRecipients,
  setSendEmailToRecipients,
  displayLink,
  setDisplayLink,
  displaySendAnotherEmail,
  setDisplaySendAnotherEmail,
  thankyouPageRedirect,
  setThankyouPageRedirect,
  redirectLink,
  setRedirectLink,
  protectFormWithPassword,
  setProtectFormWithPassword,
  passwordForm,
  setPasswordForm,
  websiteURL,
  setWebsiteURL,
  showImage,
  setShowImage,
  showDescription,
  setShowDescription,
  showTitle,
  setShowTitle,
  setOldFormId,
  oldFormId,
  directionForm,
  setDirectionForm,
  allowAccess,
  setAllowAccess,
  displayToSubUsers,
  setDisplayToSubUsers,
  formMaxHeight,
  setFormMaxHeight,
  deleteMailLink,
  setDeleteMailLink,
  viewMode,
  setViewMode,
  displayTypeSubUsers,
  setDisplayTypeSubUsers,
  listDomains,
  setListDomains,
  isCheckedPreventDisplayForm,
  setIsCheckedPreventDisplayForm,
}) => {
  const { notMobile, leptopCondition, horizontalTabletCondition } =
    useMediaQueries();
  const { getCookie } = useCookie();

  const { setModal } = useModal();
  const { getTextByKey, getPath, getLanguage, getDirection } = useContent();
  const { addToast } = useToasts();
  const [settingsMode, setSettingsMode] = useState("form");
  const [detailsMode, setDetailsMode] = useState("form-details");
  const [displaySelectIntegrateTooltip, setDisplaySelectIntegrateTooltip] =
    useState(null);
  //INVALID FIELDS:
  const [invalidURL, setInvalidURL] = useState(false);
  const [invalidEmailReceiveFiles, setInvalidEmailReceiveFiles] =
    useState(false);
  const [invalidAlert, setInvalidAlert] = useState(null);
  const [invalidFilesFormat, setInvalidFilesFormat] = useState(false);
  const [invalidTitleForm, setInvalidTitleForm] = useState(false);
  const [errorTitleText, setErrorTitleText] = useState(null);
  const [invalidDescription, setInvalidDescription] = useState(false);
  //Form Language:
  const [titleDropDown, settitleDropDown] = useState(null);
  const [dropDownLanguage, setDropDownLanguage] = useState(
    formLanguage ? formLanguage : null
  );
  const [hideSavedText, setHideSavedText] = useState(true);
  const [randomImage, setRandomImage] = useState(null);
  const [updateBeforeSave, setUpdateBeforeSave] = useState({
    mode: false,
    action: "",
    heightChanged: false,
  });
  //Security

  const [emptyDomainsError, setEmptyDomainsError] = useState(false);
  const [emptyPassword, setEmptyPassword] = useState(false);
  const [emptyOrInvalidUrl, setEmptyOrInvalidUrl] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [footerAbout, setFooterAbout] = useState("");
  const [footerTerms, setFooterTerms] = useState("");
  const [footerSupport, setFooterSupport] = useState("");
  const [newHeightCalculated, setNewHeightCalculated] = useState(
    formMaxHeight > 0 ? formMaxHeight : formHeight
  );
  const [formInnerScroll, setFormInnerScroll] = useState(
    formMaxHeight > 0 ? true : false
  );
  //Recipient validation errors
  const [recipientValidationErrors, setRecipientValidationErrors] = useState(
    {}
  );

  //Temp field
  const [tempField, setTempField] = useState({
    template: "",
    fields: {
      label: "",
      helptext: "",
      required: false,
      readonly: false,
      tempsave: false,
      downloadname: false,
      includeinemailsubject: false,
    },
  });

  useEffect(() => {
    setFormInnerScroll(formMaxHeight > 0 ? true : false);
    setNewHeightCalculated(formMaxHeight > 0 ? formMaxHeight : formHeight);
  }, [formMaxHeight, formHeight]);

  const [showModalUseBeforeUpload, setShowModalUseBeforeUpload] =
    useState(true);

  //set the language of the form by default url lang
  useEffect(() => {
    let currentLang = formLanguage
      ? formLanguage.split("-")[0]
      : getPath().split("/")[1];
    setDropDownLanguage(currentLang);
    let currentTitle = languageListObjects.filter(
      (item) => item.code === currentLang
    )[0].title;
    settitleDropDown(currentTitle);
  }, []);

  useEffect(() => {
    setSaveLoading(true);
    if (formJson) {
      if (!formId) {
        if (notMobile) {
          setUpdateBeforeSave({ mode: true, action: "create" });
        }
      } else {
        setSaveLoading(false);
      }
    }
  }, [formJson, formId]);

  //Validate all recipients in form
  const validateAllRecipientsInForm = () => {
    const recipients = tempField.fields.recipients || [];
    const allErrors = {};
    let hasError = false;
    recipients.forEach((recipient) => {
      const errors = validateRecipient(recipient);
      if (Object.keys(errors).length > 0) {
        allErrors[recipient.id] = errors;
        hasError = true;
      }
    });
    setRecipientValidationErrors(allErrors);
    return !hasError;
  };

  //Clcik on finish Button
  const saveDetails = (redirect) => {
    const isAllRecipientsValid = validateAllRecipientsInForm();
    if (!isAllRecipientsValid) {
      return;
    }
    if (
      !invalidURL &&
      !invalidEmailReceiveFiles &&
      !invalidFilesFormat &&
      !invalidAlert &&
      !invalidTitleForm &&
      !invalidDescription
    ) {
      if (isCheckedPreventDisplayForm && listDomains.length < 1) {
        setEmptyDomainsError(true);
        return;
      } else {
        setEmptyDomainsError(false);
      }

      if (protectFormWithPassword && !passwordForm) {
        setEmptyPassword(true);
      } else if (thankyouPageRedirect && !redirectLink) {
        setEmptyOrInvalidUrl(true);
      } else {
        saveFormInApi({ clickOnFinish: true, redirectToForms: redirect });
      }
    }
  };

  //Change left side mode
  const changeOptionsMode = (type) => {
    if (
      !invalidURL &&
      !invalidEmailReceiveFiles &&
      !invalidFilesFormat &&
      !invalidAlert &&
      !invalidTitleForm &&
      !invalidDescription
    ) {
      if (protectFormWithPassword && !passwordForm) {
        setEmptyPassword(true);
      } else if (thankyouPageRedirect && !redirectLink) {
        setEmptyOrInvalidUrl(true);
      }
      setSettingsMode(type);
    }
  };

  //Display Preview
  const previewFormFunction = () => {
    if (formId) {
      previewFormById();
    }
  };

  //Save form
  useEffect(() => {
    if (updateBeforeSave.mode) {
      if (
        updateBeforeSave.action === "DisplayEmbedFormOnEmbedPageSecond" ||
        updateBeforeSave.action === "UpdateHideEmbedDynamicFormImage" ||
        updateBeforeSave.action === "UpdateHideEmbedDynamicFormDescription" ||
        updateBeforeSave.action === "UpdateHideEmbedDynamicFormTitle"
      ) {
        setUpdateBeforeSave({ mode: false, action: "", heightChanged: true });
      } else if (updateBeforeSave.action === "create") {
        saveFormInApi({ clickOnFinish: false, redirectToForms: false });
      } else {
        setShowModalUseBeforeUpload(true);
      }
    }

    //check if need update height
    if (updateBeforeSave.heightChanged) {
      if (formMaxHeight > 0) {
        setNewHeightCalculated(formMaxHeight);
      } else {
        let hideHeader = false;
        if (!showTitle && !showDescription && !showImage) {
          hideHeader = true;
        }
        calculateBodyJumboForm({
          body: JSON.stringify(formJson),
          lang: formLanguage,
          includeFooter: displayFooterLinks,
          hideHeader: hideHeader,
          setState: setFormHeight,
        });
      }
    }
  }, [updateBeforeSave]);

  //add interval to save form every 5 minutes
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (formJson) {
  //       if (!formId) {
  //         if (notMobile) {
  //           //setUpdateBeforeSave({ mode: true, action: "create" });
  //         }
  //       } else {
  //         saveFormInApi({ clickOnFinish: false, redirectToForms: false });
  //       }
  //     }
  //   }, 300000);
  //   return () => clearInterval(interval);
  // }, []);

  const saveFormInApi = ({ clickOnFinish, redirectToForms }) => {
    setHideSavedText(false);

    // Check for empty recipients in recipientDropdown fields
    const checkRecipientFields = (items) => {
      let hasEmptyRecipients = false;

      items.forEach((item, index) => {
        if (
          item.template === "recipientDropdown" &&
          (!item.fields.recipients || item.fields.recipients.length === 0)
        ) {
          hasEmptyRecipients = true;
        }
      });

      return { hasEmptyRecipients };
    };

    const { hasEmptyRecipients } = checkRecipientFields(formJson.items);

    if (hasEmptyRecipients) {
      addToast(getTextByKey("recipients-required"), {
        appearance: "error",
      });

      return;
    }

    const checkIfLabelsAreUnique = (items) => {
      let labels = [];
      let unique = true;
      items.forEach((item) => {
        if (labels.includes(item.fields.label)) {
          unique = false;
        } else {
          labels.push(item.fields.label);
        }
      });
      return unique;
    };

    const areAllLabelsUnique = checkIfLabelsAreUnique(formItems);

    if (!areAllLabelsUnique) {
      addToast(getTextByKey("unique-labels"), {
        appearance: "error",
      });
      return;
    }

    const EmbedForm = {
      Embed_Dynamic_User_Id: userData.UserId,
      Embed_Dynamic_Body: JSON.stringify(formJson),
      Embed_Dynamic_Width: formWidth,
      Embed_Dynamic_Height: formHeight,
      Embed_Dynamic_Inner_Title: formDisplayTitle,
      Embed_Dynamic_Display_Title: formDisplayTitle,
      Embed_Dynamic_Culture: formLanguage,
      Embed_Dynamic_Creation_Domain: "",
      Embed_Dynamic_Creation_Culture: getPath().split("/")[1],
      Embed_Dynamic_Id: formId ? formId : 0,
      Embed_Dynamic_Description: formDescription,
      Embed_Dynamic_Buttons_Color_Code:
        formButtonsColor === embedColorCode ? "" : formButtonsColor,
      Embed_Dynamic_Button_Text_Color_Code:
        formButtonTextColor === "#fff" ? "" : formButtonTextColor,
      Embed_Dynamic_Background_Color_Code:
        formBackgroundColor === "#fff" ? "" : formBackgroundColor,
      Embed_Dynamic_Recipients: emailToReceiveFiles,
      Embed_Dynamic_Upload_Files_limit: uploadFilesLimit,
      Embed_Dynamic_Size_Id: fileSizeLimit,
      Embed_Dynamic_Manually_Delete: manuallyDeleteCheckbox,
      Embed_Dynamic_Delete_Days: parseInt(daysToDelete),
      Embed_Dynamic_Password: passwordForm,
      Embed_Dynamic_SetPassword: protectFormWithPassword,
      Embed_Dynamic_Allow_Access: allowAccess,
      Embed_Dynamic_Send_Lead: potentialCustomers,
      Embed_Dynamic_Send_Download: customersFilesDownloaded,
      Embed_Dynamic_End_Redirect: thankyouPageRedirect,
      Embed_Dynamic_End_Redirect_Url: redirectLink,
      Embed_Dynamic_Send_Copy: orderConfirmation,
      Embed_Dynamic_Send_Mail_Recipients: sendEmailToRecipients,
      Embed_Dynamic_End_Download_Link: displayLink,
      Embed_Dynamic_Display_Footer_Links: displayFooterLinks,
      Embed_Dynamic_Custom_Footer_Links: editCustomFooterLinks,
      Embed_Dynamic_End_Send_Button: displaySendAnotherEmail,
      Embed_Dynamic_Formats: fileFormats,
      Embed_Dynamic_Url: websiteURL,
      Embed_Dynamic_Image_Url: randomImage ? randomImage : "",
      Embed_Dynamic_Formats_Action: denyForamtsCheckbox
        ? "Exclude"
        : allowFolowingFormatsCheckbox
        ? "Only"
        : null,
      Embed_Dynamic_Hide_Image: showImage,
      Embed_Dynamic_Hide_Description: showDescription,
      Embed_Dynamic_Hide_Title: showTitle,
      Embed_Dynamic_Direction: directionForm,
      Embed_Dynamic_Display_To_Sub_Users: displayToSubUsers,
      Embed_Dynamic_Max_Height: formMaxHeight,
      Embed_Dynamic_Delete_Mail_Link: deleteMailLink,
      ViewMode: viewMode,
      DisplayTypeSubUsers: displayTypeSubUsers,
      DisplayOnlyOnDomains: isCheckedPreventDisplayForm,
      ListedDomains: listDomains,
    };
    const requestBody = {
      EmbedForm: EmbedForm,
      FooterLinks: displayFooterLinks ? linkFooters : null,
    };
    if (
      !invalidURL &&
      !invalidEmailReceiveFiles &&
      !invalidFilesFormat &&
      !invalidAlert &&
      !invalidTitleForm &&
      !invalidDescription &&
      formDisplayTitle &&
      formJson
    ) {
      getRes(
        createEmbedDynamicFormReact({
          body: requestBody,
          setFormId: setFormId,
          formId: formId,
          pathLang: getPath(),
        }),
        redirectToForms,
        () => {
          addToast(getTextByKey("saved-form-toast"), {
            appearance: "success",
          });
        }
      );
    } else {
      if (invalidURL) {
        // addToast(getTextByKey("invalid-url-address"), {
        //   appearance: "error",
        // });
      } else if (invalidEmailReceiveFiles) {
        // addToast(getTextByKey("invalid-email-address"), {
        //   appearance: "error",
        // });
      } else if (invalidTitleForm) {
        addToast(getTextByKey("validate-form-name"), {
          appearance: "error",
        });
      } else if (invalidDescription) {
        addToast(getTextByKey("validate-form-description"), {
          appearance: "error",
        });
      } else if (invalidAlert) {
        // addToast(invalidAlert, {
        //   appearance: "error",
        // });
      } else if (!formDisplayTitle) {
        setInvalidTitleForm(true);
        addToast(getTextByKey("form-name-required"), {
          appearance: "error",
        });
      }
      console.log("error");
    }
  };

  const getRes = async (res, redirectToForms, callback) => {
    setShowModalUseBeforeUpload(false);
    let result = await res;
    console.log("!!!result", result);
    if (result && result.status === "success") {
      callback && callback();
      if (result.data && result.data.resultCode === 0) {
        if (redirectToForms) {
          const checkIfConfirm = getCookie(`confirmTerms-${formId}`);
          if (checkIfConfirm !== "true" && !displayOnEmbedPage) {
            setDisplaySelectIntegrateTooltip(true);
            changeOptionsMode("publish");
          } else {
            window.location.href =
              config.baseurl + getPath() + "user/jumbo-forms/form-management";
          }
        }

        if (!oldFormId) {
          setOldFormId(result.data.form.EmbedForm.Embed_Dynamic_Id);
          if (!updateBeforeSave.mode) {
            setTimeout(() => {
              window.location.href =
                config.baseurl +
                getPath() +
                "create-form/" +
                result.data.form.EmbedForm.Embed_Dynamic_Id;
            }, 500);
          } else {
            if (updateBeforeSave.action === "uploadImage") {
              setModal(() => (
                <EmbedFormLogoUploader
                  formId={result.data.form.EmbedForm.Embed_Dynamic_Id}
                  logoImage={formImage}
                  setLogoImage={setFormImage}
                  firstUpdate={true}
                />
              ));
            } else {
              window.location.href =
                config.baseurl +
                getPath() +
                "create-form/" +
                result.data.form.EmbedForm.Embed_Dynamic_Id;
            }
          }
        }
      }
    }
    setUpdateBeforeSave({ mode: false, action: "", heightChanged: false });
    setTimeout(() => {
      setHideSavedText(true);
    }, 3000);
  };

  //Set random image
  useEffect(() => {
    if (formImage && formImage.includes("static/media/")) {
      let formImageNameList = formImage.split("static/media/");
      const formImageName = formImageNameList[1].split(".")[0];
      setRandomImage(formImageName);
    } else {
      setRandomImage(null);
    }
  }, [formImage]);

  //Set Footer Form
  useEffect(() => {
    if (getLanguage()) {
      //getSpecificReactConst
      getSpecificReactConst({
        key: "about-footer",
        lang: getLanguage(),
        setState: setFooterAbout,
      });
      getSpecificReactConst({
        key: "support-footer",
        lang: getLanguage(),
        setState: setFooterSupport,
      });
      getSpecificReactConst({
        key: "terms-footer",
        lang: getLanguage(),
        setState: setFooterTerms,
      });
    }
  }, [getLanguage()]);

  useEffect(() => {
    const newFooterLinks = [
      {
        FooterLinkTitle: footerAbout
          ? footerAbout
          : getTextByKey("about-footer"),
        FooterLinkUrl: config.baseurl + getPath() + "jumbo-forms",
      },
      {
        FooterLinkTitle: footerSupport
          ? footerSupport
          : getTextByKey("support-footer"),
        FooterLinkUrl: config.baseurl + getPath() + "support/jumbo-embed",
      },
      {
        FooterLinkTitle: footerTerms
          ? footerTerms
          : getTextByKey("terms-footer"),
        FooterLinkUrl: config.baseurl + getPath() + "terms",
      },
    ];
    if (displayFooterLinks && !editCustomFooterLinks) {
      setLinkFooters(newFooterLinks);
    }
  }, [footerAbout, footerSupport, footerTerms]);

  const [embedDynamicPageId, setEmbedDynamicPageId] = useState(null);
  const [userEmbedPage, setUserEmbedPage] = useState(null);
  const [notExistEmbedPage, setNotExistEmbedPage] = useState(false);
  const [displayOnEmbedPage, setDisplayOnEmbedPage] = useState(false);

  const getEmbedPageByUserId = async () => {
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedDynamicPageByUserId"
    );
    if (response.status === "success") {
      if (response.data && response.data.EmbedPageId) {
        setEmbedDynamicPageId(response.data.EmbedPageId);
        setUserEmbedPage(response.data);
        setNotExistEmbedPage(false);
        if (formId > 0) {
          checkIfFormExistInEmbedPage({
            pageId: response.data.EmbedPageId,
          });
        }
      } else {
        setNotExistEmbedPage(true);
      }
    } else {
      setNotExistEmbedPage(true);
    }
  };

  const checkIfFormExistInEmbedPage = async ({ pageId }) => {
    const parameters = {
      EmbedDynamicId: formId,
      EmbedPageId: pageId,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "CheckIfEmbedDynamicFormExistInEmbedPage",
      parameters
    );
    if (response.status === "success") {
      setDisplayOnEmbedPage(response.data);
    }
  };

  useEffect(() => {
    if (embedDynamicPageId && formId && formId > 0) {
      checkIfFormExistInEmbedPage({ pageId: embedDynamicPageId });
    }
  }, [formId]);

  useMemo(() => {
    if (userData && userData.UserId && userData.UserId !== undefined) {
      getEmbedPageByUserId(userData.UserId);
    }
  }, [userData]);

  const [fieldToAdd, setFieldToAdd] = useState(null);
  const [formItems, setFormItems] = useState([]);
  const [activeField, setActiveField] = useState(null);

  const addNewField = (field) => {
    const newField = cloneDeep(fieldStructure[field.type]);
    const newUniqueLabel = generateCopiedFieldLabel(
      getTextByKey,
      getTextByKey(newField.fields.label),
      formItems,
      false
    );
    newField.fields.label = newUniqueLabel;

    setFieldToAdd(newField);
  };
  const [continueText, setContinueText] = useState(
    getTextByKey("form-continue")
  );
  const [fieldSelected, setFieldSelected] = useState(null);

  const selectFieldToEdit = (field) => {
    setFieldSelected(field);
    setDetailsMode("edit-field");
  };

  useEffect(() => {
    if (dropDownLanguage) {
      getSpecificReactConst({
        key: "form-continue",
        lang: dropDownLanguage.toLowerCase(),
        setState: setContinueText,
      });
    }
  }, [dropDownLanguage]);

  useEffect(() => {
    if (detailsMode !== "edit-field") {
      setFieldSelected(null);
      setActiveField(null);
    }
  }, [detailsMode]);

  useEffect(() => {
    if (editOrCreate === "create") {
      let newFormJson = {};
      newFormJson.items = [];
      newFormJson.formWidth = 500;
      newFormJson.formHeight = 515;
      let tempFormItems = [];
      let nameField = defaultFieldsFormBuilder["defaultName"];
      nameField.fields.label = getTextByKey(nameField.fields.label);
      let emailField = defaultFieldsFormBuilder["defaultEmail"];
      emailField.fields.label = getTextByKey(emailField.fields.label);
      let subjectField = defaultFieldsFormBuilder["defaultSubject"];
      subjectField.fields.label = getTextByKey(subjectField.fields.label);
      let commentField = defaultFieldsFormBuilder["defaultComment"];
      commentField.fields.label = getTextByKey(commentField.fields.label);
      tempFormItems.push(nameField);
      tempFormItems.push(emailField);
      tempFormItems.push(subjectField);
      tempFormItems.push(commentField);
      newFormJson.items = tempFormItems;
      setFormDisplayTitle(getTextByKey("default-title"));
      setFormDescription(getTextByKey("default-description"));
      setFormJson(newFormJson);
    }
  }, [editOrCreate]);

  const addItemsToCart = (items, source, dropResult) => {};

  useBeforeunload((e) => {
    if (showModalUseBeforeUpload) {
      e.preventDefault();
      return "Are you sure you want to leave?";
    }
  });

  //Set the accecability icon direction
  const accessabilityIcon = document.getElementById("userwayAccessibilityIcon");
  useEffect(() => {
    if (accessabilityIcon && accessabilityIcon !== undefined) {
      accessabilityIcon.style.bottom = "30px";
      if (getDirection() !== "rtl") {
        accessabilityIcon.style.left = "unset";
        accessabilityIcon.style.right = "50px";
      } else {
        accessabilityIcon.style.left = "97px";
        accessabilityIcon.style.right = "unset";
      }
    }
  }, [getDirection(), accessabilityIcon]);

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`create-form-container-new ${
        leptopCondition && "leptop-view"
      } ${horizontalTabletCondition && "tablet-view"}`}
    >
      {isDesktop ? (
        !saveLoading && editOrCreate === "edit" ? (
          <div className="create-form-body">
            <CreateFormHeader
              settingsMode={settingsMode}
              changeOptionsMode={changeOptionsMode}
              updateBeforeSave={updateBeforeSave}
              setUpdateBeforeSave={setUpdateBeforeSave}
              previewFormFunction={previewFormFunction}
              saveDetails={saveDetails}
              hideSavedText={hideSavedText}
              setShowModalUseBeforeUpload={setShowModalUseBeforeUpload}
            />
            <DndProvider backend={HTML5Backend}>
              <div className="create-form-content">
                <OptionsContainer
                  formItems={formItems}
                  setFormItems={setFormItems}
                  addNewField={addNewField}
                  addItemsToCart={addItemsToCart}
                  displaySelectIntegrateTooltip={displaySelectIntegrateTooltip}
                  setDisplaySelectIntegrateTooltip={
                    setDisplaySelectIntegrateTooltip
                  }
                  setDisplayOnEmbedPage={setDisplayOnEmbedPage}
                  displayOnEmbedPage={displayOnEmbedPage}
                  userEmbedPage={userEmbedPage}
                  setUserEmbedPage={setUserEmbedPage}
                  embedDynamicPageId={embedDynamicPageId}
                  setEmbedDynamicPageId={setEmbedDynamicPageId}
                  notExistEmbedPage={notExistEmbedPage}
                  setNotExistEmbedPage={setNotExistEmbedPage}
                  formLanguage={formLanguage}
                  setFormLanguage={setFormLanguage}
                  titleDropDown={titleDropDown}
                  settitleDropDown={settitleDropDown}
                  setDropDownLanguage={setDropDownLanguage}
                  mode={settingsMode}
                  formWidth={formWidth}
                  setFormWidth={setFormWidth}
                  formBackgroundColor={formBackgroundColor}
                  setFormBackgroundColor={setFormBackgroundColor}
                  formButtonsColor={formButtonsColor} //not used
                  setFormButtonsColor={setFormButtonsColor} //not used
                  formButtonTextColor={formButtonTextColor} //not used
                  setFormButtonTextColor={setFormButtonTextColor} //not used
                  emailToReceiveFiles={emailToReceiveFiles} //Settings
                  setEmailToReceiveFiles={setEmailToReceiveFiles}
                  uploadFilesLimit={uploadFilesLimit}
                  setUploadFilesLimit={setUploadFilesLimit}
                  fileSizeLimit={fileSizeLimit}
                  setFileSizeLimit={setFileSizeLimit}
                  manuallyDeleteCheckbox={manuallyDeleteCheckbox}
                  setManuallyDeleteCheckbox={setManuallyDeleteCheckbox}
                  automaticallyDeleteCheckbox={automaticallyDeleteCheckbox}
                  setAutomaticallyDeleteCheckbox={
                    setAutomaticallyDeleteCheckbox
                  }
                  daysToDelete={daysToDelete}
                  setDaysToDelete={setDaysToDelete}
                  uploadAnyFormatsCheckbox={uploadAnyFormatsCheckbox}
                  setUploadAnyFormatsCheckbox={setUploadAnyFormatsCheckbox}
                  allowFolowingFormatsCheckbox={allowFolowingFormatsCheckbox}
                  setAllowFolowingFormatsCheckbox={
                    setAllowFolowingFormatsCheckbox
                  }
                  denyForamtsCheckbox={denyForamtsCheckbox}
                  setDenyForamtsCheckbox={setDenyForamtsCheckbox}
                  fileFormats={fileFormats}
                  setFileFormats={setFileFormats}
                  potentialCustomers={potentialCustomers}
                  setPotentialCustomers={setPotentialCustomers}
                  customersFilesDownloaded={customersFilesDownloaded}
                  setCustomersFilesDownloaded={setCustomersFilesDownloaded}
                  orderConfirmation={orderConfirmation}
                  setOrderConfirmation={setOrderConfirmation}
                  sendEmailToRecipients={sendEmailToRecipients}
                  setSendEmailToRecipients={setSendEmailToRecipients}
                  displayLink={displayLink}
                  setDisplayLink={setDisplayLink}
                  displaySendAnotherEmail={displaySendAnotherEmail}
                  setDisplaySendAnotherEmail={setDisplaySendAnotherEmail}
                  thankyouPageRedirect={thankyouPageRedirect}
                  setThankyouPageRedirect={setThankyouPageRedirect}
                  redirectLink={redirectLink}
                  setRedirectLink={setRedirectLink}
                  protectFormWithPassword={protectFormWithPassword}
                  setProtectFormWithPassword={setProtectFormWithPassword}
                  passwordForm={passwordForm}
                  setPasswordForm={setPasswordForm}
                  allowAccess={allowAccess}
                  setAllowAccess={setAllowAccess}
                  setInvalidFilesFormat={setInvalidFilesFormat}
                  invalidFilesFormat={invalidFilesFormat}
                  setInvalidAlert={setInvalidAlert}
                  invalidAlert={invalidAlert}
                  invalidEmailReceiveFiles={invalidEmailReceiveFiles}
                  setInvalidEmailReceiveFiles={setInvalidEmailReceiveFiles}
                  setUpdateBeforeSave={setUpdateBeforeSave}
                  EmbedDynamicId={formId}
                  formHeight={formHeight}
                  websiteURL={websiteURL}
                  setWebsiteURL={setWebsiteURL}
                  invalidURL={invalidURL}
                  setInvalidURL={setInvalidURL}
                  directionForm={directionForm} //not used
                  setDirectionForm={setDirectionForm}
                  emptyPassword={emptyPassword}
                  setEmptyPassword={setEmptyPassword}
                  emptyOrInvalidUrl={emptyOrInvalidUrl}
                  setEmptyOrInvalidUrl={setEmptyOrInvalidUrl}
                  displayToSubUsers={displayToSubUsers}
                  setDisplayToSubUsers={setDisplayToSubUsers}
                  formMaxHeight={formMaxHeight}
                  setFormMaxHeight={setFormMaxHeight}
                  deleteMailLink={deleteMailLink}
                  setDeleteMailLink={setDeleteMailLink}
                  setHideSavedText={setHideSavedText}
                  viewMode={viewMode}
                  setViewMode={setViewMode}
                  displayTypeSubUsers={displayTypeSubUsers}
                  setDisplayTypeSubUsers={setDisplayTypeSubUsers}
                  listDomains={listDomains}
                  setListDomains={setListDomains}
                  isCheckedPreventDisplayForm={isCheckedPreventDisplayForm}
                  setIsCheckedPreventDisplayForm={
                    setIsCheckedPreventDisplayForm
                  }
                  emptyDomainsError={emptyDomainsError}
                  setEmptyDomainsError={setEmptyDomainsError}
                />
                <FormBuilderContainer
                  directionForm={directionForm}
                  formItems={formItems}
                  setFormItems={setFormItems}
                  formJson={formJson}
                  setFormJson={setFormJson}
                  fieldToAdd={fieldToAdd}
                  setFieldToAdd={setFieldToAdd}
                  detailsMode={detailsMode}
                  setDetailsMode={setDetailsMode}
                  showImage={showImage}
                  formImage={formImage}
                  showTitle={showTitle}
                  formDescription={formDescription}
                  showDescription={showDescription}
                  formDisplayTitle={formDisplayTitle}
                  linkFooters={linkFooters}
                  formButtonsColor={formButtonsColor}
                  formButtonTextColor={formButtonTextColor}
                  displayFooterLinks={displayFooterLinks}
                  selectFieldToEdit={selectFieldToEdit}
                  continueText={continueText}
                  activeField={activeField}
                  setActiveField={setActiveField}
                  setFieldSelected={setFieldSelected}
                  setUpdateBeforeSave={setUpdateBeforeSave}
                  formLanguage={formLanguage}
                  formBackgroundColor={formBackgroundColor}
                  formWidth={formWidth}
                  setFormHeight={setFormHeight}
                  newHeightCalculated={newHeightCalculated}
                  formInnerScroll={formInnerScroll}
                />
                <DetailsContainer
                  formImage={formImage}
                  setFormImage={setFormImage}
                  EmbedDynamicId={formId}
                  detailsMode={detailsMode}
                  setFormDisplayTitle={setFormDisplayTitle}
                  formDisplayTitle={formDisplayTitle}
                  formDescription={formDescription}
                  setFormDescription={setFormDescription}
                  linkFooters={linkFooters}
                  setLinkFooters={setLinkFooters}
                  editCustomFooterLinks={editCustomFooterLinks}
                  setEditCustomFooterLinks={setEditCustomFooterLinks}
                  displayFooterLinks={displayFooterLinks}
                  setDisplayFooterLinks={setDisplayFooterLinks}
                  showImage={showImage}
                  setShowImage={setShowImage}
                  showDescription={showDescription}
                  setShowDescription={setShowDescription}
                  showTitle={showTitle}
                  setShowTitle={setShowTitle}
                  invalidDescription={invalidDescription}
                  setInvalidDescription={setInvalidDescription}
                  invalidTitleForm={invalidTitleForm}
                  setInvalidTitleForm={setInvalidTitleForm}
                  updateBeforeSave={updateBeforeSave}
                  setUpdateBeforeSave={setUpdateBeforeSave}
                  footerAbout={footerAbout}
                  footerSupport={footerSupport}
                  footerTerms={footerTerms}
                  formButtonsColor={formButtonsColor}
                  setFormButtonsColor={setFormButtonsColor}
                  formButtonTextColor={formButtonTextColor}
                  setFormButtonTextColor={setFormButtonTextColor}
                  formItems={formItems}
                  setFormItems={setFormItems}
                  fieldSelected={fieldSelected}
                  formJson={formJson}
                  setFormJson={setFormJson}
                  formLanguage={formLanguage}
                  errorTitleText={errorTitleText}
                  setErrorTitleText={setErrorTitleText}
                  setFormHeight={setFormHeight}
                  tempField={tempField}
                  setTempField={setTempField}
                  recipientValidationErrors={recipientValidationErrors}
                  setRecipientValidationErrors={setRecipientValidationErrors}
                />
              </div>
            </DndProvider>
          </div>
        ) : (
          <LoadingContainerElement />
        )
      ) : (
        <div className="only-computer-mod">
          <div className="empty-personal-container">
            <Image name="personal/empty-personal-page" alt="" title="" />
            <h2>{getTextByKey("only-compute-title")}</h2>
            <p>{getTextByKey("only-compute-text")}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateFormContainer;
